import { useState, useEffect, useCallback } from "react";
import { DataGridPro as DataGrid } from "@mui/x-data-grid-pro";
import EditIcon from "@mui/icons-material/Edit";
import { Box } from "@mui/material";
import { useApi } from "../../utils/Api";
import Translate from "../../utils/Translate";
import { formatDate } from "../../utils/dateTimeFormat";
import Preloader from "../../components/Preloader";
import DotMenu from "../../components/DotMenu";
import LicenseAgreementEditDialog from "../../components/admin/license-agreements/LicenseAgreementEditDialog";

export default function LicenseAgreementsPage() {
  const api = useApi();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const reload = useCallback(async () => {
    setLoading(true);
    const response = await api.fetch(`${import.meta.env.VITE_MAIN_URL}licenses/license-agreements`, false, "GET");
    if (Array.isArray(response)) {
      setRows(response);
    }
    setLoading(false);
  }, [api]);

  useEffect(() => {
    reload();
  }, [reload]);

  const columns = [
    {
      field: "forEPortCloudLicenseType",
      headerName: Translate.get("ePortCloudLicenseType"),
      flex: 1,
      valueFormatter: (value) =>
        value
          ? Translate.getEPortCloudLicenseType(value)
          : Translate.get("All").charAt(0).toUpperCase() + Translate.get("All").slice(1),
    },
    {
      field: "forEPortCloudLicenseLineType",
      headerName: Translate.get("EPortProfile"),
      flex: 1,
      valueFormatter: (value) => (value ? Translate.getEPortLicenseLineType(value) : Translate.get("DefaultEPortCloudLicenseLineType")),
    },
    {
      field: "country",
      headerName: Translate.get("Country"),
      flex: 1,
      valueFormatter: (value) => Translate.getCountryEnum(value),
    },
    { field: "version", headerName: Translate.get("Version"), flex: 1 },
    {
      field: "regDate",
      headerName: Translate.get("Date"),
      flex: 1,
      valueFormatter: (value) => formatDate(value),
    },
    {
      field: "dotMenu",
      headerName: "",
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      align: "right",
      renderCell: (params) => (
        <DotMenu
          horizontal
          content={[
            {
              icon: <EditIcon />,
              text: Translate.get("Alter"),
              dialogHeader: Translate.get("Alter"),
              customClass: "hugeDialog",
              component: <LicenseAgreementEditDialog row={params.row} onSaved={reload} />,
            },
          ]}
        />
      ),
    },
  ];

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      {loading ? (
        <Preloader />
      ) : (
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) =>
            `${row.country}-${row.licenseAgreementId}-${row.forEPortCloudLicenseType ?? ""}-${row.forEPortCloudLicenseLineType ?? ""}-${row.forExternalAgreementPartId ?? ""}-${row.forRoleId ?? ""}`
          }
          disableRowSelectionOnClick
        />
      )}
    </Box>
  );
}
